module.exports = __webpack_public_path__ + "img/workshop_ursachen.1f9a767b.png";